import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
export default {
  DoCreateChatSession(input) {
    let _input = {
      chatSessionType: input.chatSessionType,
      chatSessionName: input.chatSessionName,
      dataDefault: input.dataDefault,
      message: input.message,
    };
    return API.peakVirtualCFOAPI
      .post("/api/aiChat/CreateChatSession", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.log("err", err.config);
      });
  },
  DoCreateChatHistory(input) {
    let _input = {
      chatSessionId: input.chatSessionId,
      message: input.message,
    };
    return API.peakVirtualCFOAPI
      .post("/api/aiChat/CreateChatHistory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantTokenRemainingPercent() {
    return API.peakVirtualCFOAPI
      .post("/api/aiChat/GetMerchantTokenRemainingPercent", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
